import { config } from "../state";
import Toggle from "./Toggle";

const NavConfigRov = configItem => {
  const elm = document.createElement("div");
  const onClick = () => {
    config.updated = true;
    config[configItem.id] = !config[configItem.id];
  };
  elm.classList.add("nav-config-btn");
  elm.innerHTML = configItem.label;
  elm.prepend(Toggle(onClick, config[configItem.id]));
  return elm;
};

export default NavConfigRov;
